import axios from 'axios';
import {API_BASE_URL} from 'configs/AppConfig';
import {signOutSuccess} from 'store/slices/authSlice';
import store from '../store';
import {AUTH_TOKEN} from 'constants/AuthConstant';
import {notification} from 'antd';

const unauthorizedCode = [400, 401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000
});

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';

// API Request interceptor
service.interceptors.request.use(
    config => {
      const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

      if (jwtToken) {
        config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
      }

      return config;
    },
    error => {
      notification.error({
        message: `Server Error`,
        description: 'Unable to connect with server.',
      });
      return Promise.reject(error); // Properly return the rejected promise
    }
);

// API Response interceptor
service.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response) {
        const status = error.response.status;

        if (unauthorizedCode.includes(status)) {
          notification.error({
            message: 'Authentication Failed',
            description: 'Please login again.',
          });

          localStorage.removeItem(AUTH_TOKEN);
          store.dispatch(signOutSuccess());
        }
      }

      return Promise.reject(error); // Properly return the rejected promise
    }
);

export default service;
